/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon94IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon94Icon(props: Icon94IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M15.555 2.105a1 1 0 0 1 1.026.082l14 10a1 1 0 0 1 .373 1.11l-5 16A1 1 0 0 1 25 30H7a1 1 0 0 1-.954-.702l-5-16a1 1 0 0 1 .373-1.111l14-10zM3.17 13.393 7.734 28h16.532l4.563-14.607L16 4.229z"
        }
      ></path>
    </svg>
  );
}

export default Icon94Icon;
/* prettier-ignore-end */
